const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

const Modal = require('app/ui/Modal');
const ConfirmModal = require('app/ui/modal/Confirm');
const ListTable = require('app/ui/list/Table');

const UserForm = require('app/restaurant/user/Form');
const UserPicker = require('app/restaurant/user/Picker');


class UserTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'restaurant': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitUserSucceed = this.onSubmitUserSucceed.bind(this);
        this.onPickUserSucceed = this.onPickUserSucceed.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.restaurant = this.settings.restaurant;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$list = $('<div/>');

        this.$btnCreate = $("<button/>")
        .attr('type',"button")
        .addClass('btn btn-success')
        .attr('title',window.translate('app.restaurant.show.tabs.user.actions.create.label'))
        .append(
            $('<i/>')
            .addClass('fas fa-plus-circle')
        )
        .on("click",function(event){
            self.onClickCreate();
        })


        this.$btnPick = $("<button/>")
        .attr('type',"button")
        .addClass('btn btn-primary')
        .attr('title',"Associer un utilisateur d'un autre restaurant à ce restaurant")
        .append(
            $('<i/>')
            .addClass('fas fa-hand-pointer')
        )
        .on("click",function(event){
            self.onClickPick();
        })


        this.$container
        .html('')
        .addClass('white-box p-2')
        .append(
            $('<div/>')
            .addClass('float-end')
            .append(this.$btnPick)
            .append("&nbsp;")
            .append(this.$btnCreate)
        )
        .append(this.$list);

        this.loadData();
    }

    refresh(){
        console.log("call refresh");
        this.loadData();
    }

    loadData(){
        var self = this;

        let queries = [
            this.buildUserQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildList(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildUserQuery(){
        var self = this;

        let id = this.restaurant.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'userAssociations { user { id createdAt firstName lastName email login restaurantAssociations { restaurant { id name } } } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurant',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildList(data){
        var self = this;
        this.users = data.restaurant.userAssociations;

        this.$list.html('');

        this.table = new ListTable({
            '$container': this.$list,
            'tableClass': 'table table-striped restaurant-user-list',
            'id': 'list-users',
            'length': 50,
            'data': this.users,
            'columns': [
                {
                    'name': 'createdAt',
                    'label': window.translate('app.restaurant.show.tabs.user.createdAt.label'),
                    'class': 'user-date',
                    'render': function(item,index){
                        if(item.user.createdAt){
                            return window.formatDate(item.user.createdAt,window.translate('momentDateFormat.fullDay'));
                        }else{
                            return $('<i/>').addClass('fas fa-exclamation-triangle text-danger');
                        }
                    },
                },
                {
                    'name': 'firstName',
                    'label': window.translate('app.restaurant.show.tabs.user.fullName.label'),
                    'class': 'user-name',
                    'render': function(item,index){
                        return item.user.firstName + ' ' + item.user.lastName;
                    },
                },
                {
                    'name': 'email',
                    'label': window.translate('app.restaurant.show.tabs.user.email.label'),
                    'class': 'user-email',
                    'render': function(item,index){
                        return item.user.email;
                    },
                },
                {
                    'name': 'login',
                    'label': window.translate('app.restaurant.show.tabs.user.login.label'),
                    'class': 'user-login',
                    'render': function(item,index){
                        return item.user.login;
                    },
                },
                {
                    'name': 'restaurants',
                    'label': "Autre(s) restaurant(s) associé(s)",
                    'class': 'user-login',
                    'render': function(item,index){
                        let nb =  item.user.restaurantAssociations.length;
                        let count = nb - 1;
                        if(count <= 0){
                            return "aucun";
                        }
                        let $content = $('<ul/>')
                        .addClass('list-unstyled')

                        for(var i in item.user.restaurantAssociations){
                            let restaurant = item.user.restaurantAssociations[i].restaurant;
                            if(restaurant.id != self.restaurant.id){
                                $content.append(
                                    $('<li/>')
                                    .append(restaurant.name)
                                )
                            }
                        }

                        return $content;
                    },
                },
                {
                    'name': 'action',
                    'label': '',
                    'class': 'user-action',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-inline btn-list-inline');

                        
                        let btns = [];

                        let $btnEdit = $('<button/>')
                        .attr('type','button')
                        .attr('data-id',item.user.id)
                        .addClass('btn btn-link btn-edit')
                        .attr('data-fancybox','')
                        .attr('data-type','iframe')
                        .attr('title',window.translate('app.restaurant.show.tabs.user.actions.edit.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-edit')
                        )
                        .on('click',function(event){
                            let $btn = $(this);
                            let id = $btn.data('id')
                            self.onClickEdit(id)
                        });
                        btns.push($btnEdit);

                        let $btnModalDelete = $('<button/>')
                        .attr('type','button')
                        .attr('data-id',item.user.id)
                        .addClass('btn btn-link btn-delete text-danger iframe fancy')
                        .attr('data-fancybox','')
                        .attr('data-type','iframe')
                        .attr('title',window.translate('app.restaurant.show.tabs.user.actions.delete.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-trash')
                        )
                        .on('click',function(event){
                            let $btn = $(this);
                            let id = $btn.data('id')
                            self.onClickDelete(id)
                        });
                        btns.push($btnModalDelete);

                        for(var i in btns){
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                .addClass('list-inline-item')
                                .append($btn)
                            );
                        }

                        return $list;
                    },
                }
            ]
        });
    }

    onClickEdit(id){
        this.showModal(id);
    }

    onClickDelete(id){
        var self = this;
        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.restaurant.show.tabs.user.actions.delete.confirm'))
        )

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedDelete(id,modal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();
    }

    proceedDelete(id,confirmModal){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            },
            'user': {
                'value': id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteRestaurantContact",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                confirmModal.dispose();
                window.notify(data.message,'success');
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.dispose();
                window.notify(message,'error');
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();

    }

    onClickCreate(){
        this.showModal();
    }

    onClickPick(){
        this.showModalPicker();
    }

    showModal(id){
        var self = this;

        let form = new UserForm({
            'restaurant': this.restaurant,
            'userId': id,
            'success': this.onSubmitUserSucceed
        })
        let title = window.translate('app.restaurant.show.tabs.user.actions.create.label');
        if(id){
            window.translate('app.restaurant.show.tabs.user.actions.edit.label');
        }

        let $content = form.getForm();

        this.modalForm = new Modal({
            'id': 'userform'+id,
            'title': title,
            'showFooter': false,
            'content' : $content,
            'modalSize': "xl",

            'onShown': function(){

            },
            'onClose': function(event){
                self.refresh();
            },

        });

        this.modalForm.show();
    }

    showModalPicker(){
        var self = this;

        let picker = new UserPicker({
            'restaurant': this.restaurant,
            'success': this.onPickUserSucceed
        })
        let title = "Associer un utilisateur d'un autre restaurant à ce restaurant";

        let $content = picker.getContent();

        this.modalPicker = new Modal({
            'id': 'userpicker',
            'title': title,
            'showFooter': false,
            'content' : $content,
            'modalSize': "xl",

            'onShown': function(){

            },
            'onClose': function(event){
                self.refresh();
            },

        });

        this.modalPicker.show();
    }

    onSubmitUserSucceed(data){
        this.modalForm.dispose();
        this.refresh();
    }

    onPickUserSucceed(data){
        console.log("ON SUCCESS NEW ASSS",data);
        this.modalPicker.dispose();
        this.refresh();

    }
}

module.exports = UserTab;

